/**
 * True when `target` received focus the way `:focus-visible` defines it (keyboard
 * or script, not a pointer press), so a focus ring is drawn only for keyboard
 * users, as the browser's own ring would be. jsdom does not implement the
 * selector and throws; treat that as keyboard focus so tests see the ring.
 */
export const isKeyboardFocus = (target: EventTarget | null): boolean => {
  if (!(target instanceof Element)) return false;
  try {
    return target.matches(':focus-visible');
  } catch {
    return true;
  }
};
